import {computed} from "vue";
import {isOnLocalDomain} from "@/composables/useLocalDomains";
import useUser from "@/composables/useUser";
import useFeatureReleaseTracker from "@/composables/useFeatureReleaseTracker";

const useKit = () => {
  const {isAdmin, isLoading: isUserLoading, isOnTrial} = useUser();
  const {afterKitLaunchDate} = useFeatureReleaseTracker();

  const canSeeKit = computed(() => {
    if (isAdmin.value || isOnTrial.value) {
      return true;
    }

    // Kit should only be shown on local domains and not whitelabel
    if (!isOnLocalDomain.value) {
      return false;
    }

    return afterKitLaunchDate;
  });

  return {
    canSeeKit,
    isUserLoading,
  };
};

export default useKit;
